export default {
  lang: {
    reset: 'Tetapkan semula',
    search: 'Penapis',
    expand: 'Kembangkan',
    collapse: 'Simpanan',
  },
};
